var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAaveV4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "url(#paint0_linear_3546_58162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1055 18.666C21.7532 18.666 23.0889 20.0016 23.0889 21.6494C23.0888 23.2973 21.7532 24.6328 20.1055 24.6328C18.4578 24.6327 17.1221 23.2973 17.1221 21.6494C17.1221 20.0016 18.4578 18.6661 20.1055 18.666ZM27.9033 18.666C29.5511 18.666 30.8877 20.0016 30.8877 21.6494C30.8877 23.2973 29.5511 24.6328 27.9033 24.6328C26.2558 24.6326 24.92 23.2972 24.9199 21.6494C24.9199 20.0017 26.2558 18.6662 27.9033 18.666ZM24 9.33301C32.1002 9.33301 38.6684 16.0269 38.667 24.2812H34.9199C34.9199 18.0952 30.0695 13.0801 24 13.0801C17.9305 13.0801 13.0801 18.0952 13.0801 24.2812H9.33301C9.33092 16.0269 15.8991 9.33301 24 9.33301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0177 38.9332V36.835H24.6787V35.9931L28.8105 29.8666H30.1057V35.8506H31.401V36.835H30.1057V38.9332H29.0177ZM25.8962 35.8506H29.0695V31.1359L25.8962 35.8506Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4898 38.9332L16.6014 29.8666H17.7672L20.1374 37.5214L22.5077 29.8666H23.6864L20.7851 38.9332H19.4898Z",
    fill: "#F9FAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3546_58162",
    x1: 24,
    y1: 0,
    x2: 24.1542,
    y2: 47.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9391F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6562F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaveV4);
export default __webpack_public_path__ + "static/media/aave-v4.246afe906e911137e77f815a1475615b.svg";
export { ForwardRef as ReactComponent };